import { render } from "./HomeDiovoid.vue?vue&type=template&id=3f8bd554&ts=true"
import script from "./HomeDiovoid.vue?vue&type=script&lang=ts"
export * from "./HomeDiovoid.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__